import { z } from "zod";

import { Operator } from "@skilitics/judy/operators";

import { ReferencedValue, ValueConfig, ValueTombstone } from "./valueConfig.ts";

/**
 * A design-time comparison of a subject value against 0–2 operands. Its only
 * runtime manifestation is a judy Condition, built at publish — no runtime
 * expression type exists.
 *
 * The subject is reference-only: the expression's type and subtype derive from
 * the subject's value descriptor and are never stored. A tombstone stands in
 * for the subject when its node has been removed — the preserved signature
 * keeps the expression editable. Operands are arity-stable `value`/`value2`;
 * judy's `object`/`left`/`right` appear only in the built condition. Every part is
 * optional because an expression is authored a part at a time.
 */
export const ValueExpression = z.object({
  subject: z.union([ReferencedValue, ValueTombstone]).optional(),
  operator: z.nativeEnum(Operator).optional(),
  value: ValueConfig.optional(),
  value2: ValueConfig.optional(),
});
export type ValueExpression = z.infer<typeof ValueExpression>;
